import {
  Accordion,
  AccordionTypes,
  Box,
  Icon,
  Text,
  HStack,
  VStack,
  IconStatusNew,
} from '@genial/components';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../components/TableContent';
import { FixedFeeTermDetails } from '../FixedFeeTermDetails';
import { FixedFeeRowActions } from '../shared/FixedFeeRowActions';
import { HasRelatedTermFlag } from '../shared/HasRelatedTermFlag';

import { FixedFeeTermsRowProps } from '.';

export const FixedFeeTermsRowMobile: React.FC<FixedFeeTermsRowProps> = ({ item }) => {
  const [accordionState, setAccordionState] = React.useState<AccordionTypes.Status>('closed');

  const handleToggleAccordion = () => {
    setAccordionState((state) => (state === 'closed' ? 'opened' : 'closed'));
  };

  const handleCloseAccordion = () => {
    setAccordionState('closed');
  };

  return (
    <Accordion
      status={accordionState}
      onPress={handleToggleAccordion}
      onClosed={handleCloseAccordion}
      hasShadow={false}>
      <Accordion.Visible
        containerProps={{ paddingBottom: 0, paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
        padding={0}
        hideDefaultIcons>
        <TableContent direction="column" alignItems="stretch" space="stack.xxxs">
          <HStack justifyContent="space-between" alignItems="flex-start" space="inline.nano">
            <VStack space="inline.quarck" flex={1}>
              <HStack space="inline.quarck" alignItems="center">
                <Text variant="semibold">{item.term}</Text>
                <HasRelatedTermFlag hasRelatedTerm={!!item.relatedTerm} />
              </HStack>
              <IconStatusNew color={item.statusColor} icon={item.statusIcon} status={item.status} />
            </VStack>
            <FixedFeeRowActions feeTerm={item} />
          </HStack>

          <Box h="1px" bg="neutral.lightest" />

          <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
            <Text flex={1}>{item.customerName}</Text>
            <Pressable onPress={handleToggleAccordion}>
              <Icon
                name={accordionState === 'opened' ? 'ChevronUp' : 'ChevronDown'}
                size="xxs"
                color="neutral.dark"
              />
            </Pressable>
          </HStack>
        </TableContent>
      </Accordion.Visible>
      <Accordion.Expanded>
        <FixedFeeTermDetails fixedFeeTerm={item} />
      </Accordion.Expanded>
    </Accordion>
  );
};
